export default __webpack_public_path__ + "static/media/AAGP-Logo.34d65cf5.png";